import { gql } from "@apollo/client"
import { compact } from "lodash-es"
import { useMemo } from "react"
import { useQuery } from "@oysterhr/core"
import {
  getCurrentBenefitsEnrolledPackage,
  getEnrolledBenefitsPackagedEnrollments,
} from "../../utils/benefits"
import { Query } from "@oysterhr/schema"

const TEAM_MEMBER_PACKAGE_ENROLLMENTS = gql`
  query BenefitsStaffTeamMemberPackageEnrollments($engagementId: ID!) {
    engagement(engagementId: $engagementId) {
      id
      benefitsEnrolledPackages {
        collection {
          id
          enrollments {
            collection {
              id
              state
              coverageEndDate
              plan {
                id
                name
                descriptiveName
                provider {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`

export const useTeamMemberPackageEnrollments = (engagementId: string) => {
  const { data, ...rest } = useQuery<Pick<Query, "engagement">>(TEAM_MEMBER_PACKAGE_ENROLLMENTS, {
    variables: {
      engagementId,
    },
    fetchPolicy: "cache-and-network",
  })

  const benefitsPackagedEnrolledEnrollments = useMemo(() => {
    const currentPackage = getCurrentBenefitsEnrolledPackage(data?.engagement)
    return getEnrolledBenefitsPackagedEnrollments(currentPackage)
  }, [data?.engagement])

  return {
    ...rest,
    enrollments: useMemo(
      () => compact(benefitsPackagedEnrolledEnrollments?.map(enrollment => enrollment)) || [],
      [benefitsPackagedEnrolledEnrollments],
    ),
  }
}
